<div class="position-relative d-inline-block">
  
  <button class="btn btn-outline-secondary py-2" type="button" matTooltip="Configura colonne" (click)="toggleDropdown()">
    <div class="d-flex align-items-center" style="font-size:large;">
      <i class="fa-solid fa-gear" style="padding-right: 5px;"></i> <i class="fa-solid fa-caret-down"></i>
    </div>
  </button>

  <div class="dropdown-custom d-flex flex-column" *ngIf="showDropdown">
    <h6 class="dropdown-title">Configura colonne</h6>

    <div class="flex-grow-1 overflow-auto column-list" cdkDropList (cdkDropListDropped)="drop($event)">
      <div class="form-check d-flex align-items-center gap-2 mb-2" *ngFor="let col of tempColumns" cdkDrag>
        <i class="fa-solid fa-bars drag-handle"></i>
        <input type="checkbox" class="form-check-input" [checked]="col.visible" (change)="toggleColumn(col)">
        <label class="form-check-label flex-grow-1">{{ col.label }}</label>
      </div>
    </div>

    <div class="d-flex justify-content-end gap-2 mt-2 border-top pt-2">
      <button class="btn btn-sm btn-outline-secondary" (click)="resetConfig()">Annulla</button>
      <button class="btn btn-sm btn-primary" (click)="saveUserConfig()">Salva</button>
    </div>
  </div>
</div>
